import axios from 'axios';
import HttpHelper from '../helper/HttpHelper';

class DislikeService {

    getAll(payload) {
        return axios.get(HttpHelper.API_URL + '/dislikes', { params: payload }, HttpHelper.getHeader());
    }

    getOne(id, payload) {
        return axios.get(HttpHelper.API_URL + '/dislikes/' + id, { params: payload }, HttpHelper.getHeader());
    }

    create(payload) {
        return axios.post(HttpHelper.API_URL + '/dislikes', payload, HttpHelper.getAuthHeader());
    }

    update(id, payload) {
        return axios.put(HttpHelper.API_URL + "/dislikes/" + id, payload, HttpHelper.getAuthHeader());
    }

    delete(id) {
        return axios.delete(HttpHelper.API_URL + "/dislikes/" + id, HttpHelper.getAuthHeader());
    }

}

export default DislikeService = new DislikeService();